import React from 'react';
import { DisapproveManualWarranty } from './DisapproveManualWarranty';
import { UseMutateFunction } from '@tanstack/react-query';
import { ApproveOrDisapproveManualWarrantyModel } from 'services/creditNote/types/WarrantyModel/ManualWarrantyModel';
import { FormProvider } from 'contexts/formContext';
import { FieldValues } from 'react-hook-form';
import { disapproveManualWarrantyDefaultValue, disapproveManualWarrantyValidationSchema } from './DisapproveManualWarrantySchema';

type DisapproveMutateType = UseMutateFunction<unknown, unknown, ApproveOrDisapproveManualWarrantyModel, unknown>

type DisapproveManualWarrantyContainerProps = {
    isCancelAction: boolean;
    isCancelDisabled: boolean;
    disapproveManualWarranty: DisapproveMutateType;
    onCancel: () => void;
    isLoading: boolean;
};

export const DisapproveManualWarrantyContainer = ({
    isCancelAction,
    isCancelDisabled,
    disapproveManualWarranty,
    onCancel, 
    isLoading
}: DisapproveManualWarrantyContainerProps) => {

    const onSubmit = (values: FieldValues) => {
        const payload = {
            approve: false,
            cancel: isCancelAction,
            message: values?.message,
            listTokens: []
        } as ApproveOrDisapproveManualWarrantyModel;
        disapproveManualWarranty(payload);
    };

    return (
        <FormProvider {...{
            defaultValues: disapproveManualWarrantyDefaultValue,
            validationSchema: disapproveManualWarrantyValidationSchema(),
            onSubmit
        }}>
            <DisapproveManualWarranty
                {...{
                    isCancelAction,
                    isCancelDisabled,
                    onCancel, 
                    isLoading
                }}
            />
        </FormProvider>
    );
};
